module.exports = __webpack_public_path__ + "static/media/BraindLogowhite.68340322.svg";